export interface IWidgetList {
  title: string;
  image: string;
  type: string;
}
